import { create } from 'zustand';
import { applicationService } from 'src/services/application';
import { UNDER_REVIEW_LS_KEY } from 'src/constants';
import { useApplicationStore } from './application';

interface UnderReviewState {
  isUnderReview: boolean;
  applicationState: any;
  firstName: string;
  isModalOpen: boolean;
  
  // Actions
  checkUnderReviewStatus: () => Promise<void>;
  setModalOpen: (isOpen: boolean) => void;
  setDontShowAgain: () => void;
  resetState: () => void;
}

export const useUnderReviewStore = create<UnderReviewState>((set, get) => ({
  isUnderReview: false,
  applicationState: null,
  firstName: '',
  isModalOpen: false,

  checkUnderReviewStatus: async () => {
    try {
      // Fetch application state to check phqUnderReviewAt
      const applicationState = await applicationService.applicationState();
      
      // Check if user has disabled the modal
      const hideModal = typeof window !== 'undefined' && localStorage.getItem(UNDER_REVIEW_LS_KEY) === '1';
      
      // Check if phqUnderReviewAt is not null
      const isUnderReview = !!applicationState?.phqUnderReviewAt;

      useApplicationStore.setState({ phqUnderReviewAt: applicationState?.phqUnderReviewAt });

      set({ 
        applicationState,
        isUnderReview,
        isModalOpen: isUnderReview && !hideModal
      });
    } catch (error) {
      console.error('Failed to check under review status:', error);
      set({ isUnderReview: false, isModalOpen: false });
    }
  },

  setModalOpen: (isOpen: boolean) => {
    set({ isModalOpen: isOpen });
  },

  setDontShowAgain: () => {
    try {
      localStorage.setItem(UNDER_REVIEW_LS_KEY, '1');
    } catch (error) {
      console.error('Failed to save dont show again preference:', error);
    }
    set({ isModalOpen: false });
  },

  resetState: () => {
    set({
      isUnderReview: false,
      applicationState: null,
      firstName: '',
      isModalOpen: false,
    });
  },
}));
